module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-classic-3-73a8eeaba57e4fa27ffd9e2b5fe8c6be.webp";